import React from 'react';
import { useI18n } from '../i18n';

export default function IosInstallModal() {
  const { t } = useI18n();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('TP_SHOW_IOS_INSTALL', handler);
    return () => window.removeEventListener('TP_SHOW_IOS_INSTALL', handler);
  }, []);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
      <div className="absolute left-0 right-0 bottom-20 px-4">
        <div className="mx-auto max-w-md bg-white border border-green-100 rounded-2xl shadow-lg p-4">
          <div className="text-sm font-semibold text-green-700 mb-1">{t('ios.install.title')}</div>
          <div className="text-sm text-gray-700 mb-2">{t('ios.install.step.share')}</div>
          <div className="text-sm text-gray-700 mb-2">{t('ios.install.step.add')}</div>
          <div className="text-xs text-gray-500 mb-3">{t('ios.install.tip')}</div>
          <div className="text-right">
            <button className="text-xs bg-green-600 text-white px-3 py-1.5 rounded" onClick={() => setOpen(false)}>{t('ios.install.close')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}


